import React, { useState } from 'react'
import ReactPlayer from 'react-player'
import { videoProperties } from '../../constants'

const VideoCarousel = () => {
  const [current, setCurrent] = useState(0);

  function nextSlide() {
    setCurrent(current === videoProperties.length - 1 ? 0 : current + 1);
  }

  function prevSlide() {
    setCurrent(current === 0 ? videoProperties.length - 1 : current - 1);
  }
  return (
    <section id='video' className='background-black'>
      <div className="container text-center color-secondary" >
        <h2>Galeri Video</h2>
        <div className="slider mt-5">
          <div className="left-arrow" onClick={prevSlide}>
            ⮕
          </div>
          <div className="right-arrow" onClick={nextSlide}>
            ⮕
          </div>
          {videoProperties.map((video, index) => {
            return(
              current === index && (
                <ReactPlayer
                  key={video.id}
                  url={video.src}
                  pip={true}
                  controls={true}
                  playing={false}
                  volume={1}
                  muted={false}
                  width="740px"
                  height="460px"
                />
              )
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default VideoCarousel